// extracted by mini-css-extract-plugin
export default {"roundRadio":"roundRadio_roundRadio__iUSZf","radioInput":"roundRadio_radioInput__4utLZ","radioMark":"roundRadio_radioMark__39aKl","radioLabel":"roundRadio_radioLabel__JqmaD"};